var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5363",
    "data-name": "Group 5363",
    transform: "translate(-1210 -810)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1958",
    "data-name": "Rectangle 1958",
    width: 20,
    height: 20,
    transform: "translate(1210 810)",
    fill: "#e23744",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "phone-call",
    d: "M20.357,15.4c-.055-.043-4.023-2.9-5.113-2.7-.52.092-.817.447-1.414,1.157-.1.115-.327.389-.506.585a8.345,8.345,0,0,1-1.1-.448A9.133,9.133,0,0,1,8.009,9.781a8.305,8.305,0,0,1-.448-1.1c.2-.18.471-.411.588-.509C8.856,7.577,9.211,7.28,9.3,6.759c.189-1.08-2.67-5.076-2.7-5.112A1.526,1.526,0,0,0,5.467,1C4.308,1,1,5.291,1,6.014c0,.042.061,4.311,5.325,9.667C11.675,20.939,15.944,21,15.986,21,16.709,21,21,17.692,21,16.533a1.522,1.522,0,0,0-.643-1.133Z",
    transform: "translate(1209 809)",
    fill: "#e23744"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSmall);
export default __webpack_public_path__ + "static/media/phoneSmall.c90a90594cbba3993472585cb044dbdb.svg";
export { ForwardRef as ReactComponent };